<div class="custom-modal novo-usuario">
  <div class="header">
    <h1 mat-dialog-title>Parametrização de valores de frete</h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>

  <div mat-dialog-content>
    <div
      *ngIf="isLoading"
      class="d-flex justify-content-center align-items-center"
      style="height: 170px"
    >
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>

    <div *ngIf="!isLoading">
      <form [formGroup]="filterForm">
        <div class="element-inline">
          <mat-form-field>
            <mat-label>Roteiro</mat-label>
            <mat-select
              formControlName="roteiroSelecionado"
              disableOptionCentering="true"
              placeholder="Roteiro"
            >
              <mat-option><ngx-mat-select-search [formControl]="roteiroMultiFilter" placeholderLabel="Buscar..."
              noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option selected disabled value="">Selecione</mat-option>
              <mat-option
                *ngFor="let roteiro of filteredRoteiros | async"
                [value]="roteiro?.roteiroID"
              >
                {{ roteiro?.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Cliente</mat-label>
            <mat-select
              formControlName="clienteSelecionado"
              disableOptionCentering="true"
              placeholder="Cliente"
              (selectionChange)="listarProdutos()"
            >
              <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
              noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option
                *ngFor="let cliente of filteredClientes | async"
                [value]="cliente?.id"
              >
                {{ cliente?.nome }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="element-inline">
          <mat-form-field>
            <mat-label>Produto</mat-label>
            <mat-select
              formControlName="produtoSelecionado"
              disableOptionCentering="true"
              placeholder="Produto"
              [disableControl]="!clienteSelecionado || isLoading || !produtos?.length"
            >
              <mat-option><ngx-mat-select-search [formControl]="produtoMultiFilter" placeholderLabel="Buscar..."
              noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option
                *ngFor="let produto of filteredProdutos | async"
                [value]="produto?.produtoID"
              >
                {{ produto?.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Tipo de Veículo</mat-label>
            <mat-select
              formControlName="tipoVeiculo"
              disableOptionCentering="true"
              placeholder="Tipo de veículo"
            >
              <mat-option><ngx-mat-select-search [formControl]="veiculosMultiFilter" placeholderLabel="Buscar..."
              noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option
                *ngFor="let veiculo of filteredVeiculos | async"
                [value]="veiculo?.idTipoVeiculo"
              >
                {{ veiculo?.descTipoVeiculo }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <div class="element-inline">
            <mat-form-field>
              <mat-label>Valor Frete</mat-label>
              <input
                matInput
                currencyMask
                formControlName="valorFrete"
                placeholder="Valor do Frete"
                required
                maxlength="35"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>GRIS</mat-label>
              <input
                matInput
                mask="percent.4"
                [dropSpecialCharacters]="false"
                formControlName="gris"
                placeholder="GRIS"
                required
                maxlength="6"
                [validation]="false"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>ADV</mat-label>
              <input
                matInput
                mask="percent.4"
                [dropSpecialCharacters]="false"
                formControlName="adv"
                placeholder="ADV"
                required
                maxlength="6"
                [validation]="false"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Valor Pedágio</mat-label>
              <input
                matInput
                currencyMask
                formControlName="valorPedagio"
                placeholder="Valor Pedágio"
                required
                maxlength="35"
              />
            </mat-form-field>
            <mat-slide-toggle color="primary" formControlName="ativo">Ativo?</mat-slide-toggle>
          </div>
        </div>
      </form>
    </div>

  </div>
  <div class="modal-actions"
    mat-dialog-actions
    align="end"
  >
    <button mat-flat-button color="info" mat-dialog-close="cancel" [disabled]="isLoading">
      Cancelar
    </button>

    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="filterForm?.invalid || isLoading"
      (click)="salvarFrete()"
    >
      Salvar
    </button>
  </div>
</div>
